<template>
    <b-container fluid class="container-custom-padding pb-5">
        <div class="mb-3">
            <ProfileToolBar />
            <TabsBar></TabsBar>
        </div>
        <!-- Page heading bar -->
        <b-row>
            <!-- Left side panel -->
            <b-col cols="12" md="8" lg="9">

                <!-- Dam graphic -->
                <ProfileDamBody />
            </b-col>
            <!-- Right side panel -->
            <b-col cols="12" md="4" lg="3">
                <ProfileAside />
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import ProfileToolBar from './ProfileToolBar';
    import ProfileDamBody from './ProfileDamBody';
    import ProfileAside from './ProfileAside';
    import TabsBar from '../sensors/TabsBar';
    //vuex
    import {SET_IS_MOBILE, IS_MOBILE} from "../../store/actions/profile";
    import {mapGetters, mapActions} from "vuex";

  export default {
    name: 'ProfileContainer',
    components: {
        ProfileToolBar,
        ProfileDamBody,
        ProfileAside,
        TabsBar
    },
    data() {
        return {
            windowWidth: window.innerWidth
        }
    },
    computed: {
        ...mapGetters([IS_MOBILE]),
    },
    mounted() {
        this.$nextTick(() => {
            this.setIsMobile(this.windowWidth);
            window.addEventListener('resize', this.onResize);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        ...mapActions([SET_IS_MOBILE]),
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        setIsMobile(width) {
            if (width < 768 && !this.IS_MOBILE) {
                return this.SET_IS_MOBILE(true);
            }

            if (width >= 768 && this.IS_MOBILE) {
                return this.SET_IS_MOBILE(false);
            }
        }
    },
    watch: {
        windowWidth(newWidth) {
            this.setIsMobile(newWidth);
        }
    }
  }
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/_variables";

    @media (min-width: 992px) {
        .container-custom-padding {
            padding: 0 1.3rem;
            position: relative;
        }
    }
</style>